import { TEALIUM_PROD_ACTION } from 'b2b-apps/core/analytics/types/types';
import { ANALYZE_BARCODE_SCAN } from './actionTypes';
import { AnalyzeBarcodeScanUsageAction } from './types';

export const analyzeBarcodeScan = (
  barcodeAction: TEALIUM_PROD_ACTION,
  barcode?: string,
  sku?: string,
): AnalyzeBarcodeScanUsageAction => ({
  type: ANALYZE_BARCODE_SCAN,
  payload: {
    barcodeAction,
    barcode,
    sku,
  },
});
